import { useMutation, useQuery } from '@apollo/client';
import { convertToHTML } from 'draft-convert';
import { ContentState, convertFromHTML, Editor, EditorState, RichUtils } from 'draft-js';
import { useState, useEffect, useRef, Component } from 'react'
import { Flex, Box, Text, Heading, Button } from 'rebass/styled-components'
import styled from 'styled-components';
import Modal from 'styled-react-modal';
import { AvatarImg } from '../components/hamburgerMenu/Avatar';
import PleaseWait from '../components/PleaseWait';
import { InputFakeViewer, InputNoForm } from '../components/TextInput';
import { CHANGE_PROFILE } from '../graphql/mutations';
import { GET_PROFILE } from '../graphql/queries';
import { IChangeProfileInput, IChangeProfileOutput } from '../graphql/types/mutations/user';
import { IGetProfileOutput, IGetProfileInput } from '../graphql/types/queries/user'
import { Constants } from '../utils/Constants';

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: #C9C9C9;
  margin-top: 25px;
  margin-bottom: 25px;
`

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 0;
  
  @media screen and (min-width: 68.8125em) {
    padding: ${() => `${Constants.OUTLETS_PADDING}px`};
    padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
    min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  }
`

interface IProfileProps {

}

const Btn = styled(Flex) <{ isActive: boolean }>`
  height: 36px;
  width: 36px;
  background-color: ${({ isActive }) => isActive ? '#e5e9ec' : 'transparent'};
  justify-content: center;
  align-items: center;
  &:hover{
  background-color: #e5e9ec;
  }
`

class StyleButton extends Component<any> {
  constructor(props: any) {
    super(props);
  }
  onToggle = (e: any) => {
    e.preventDefault();
    this.props.onToggle(this.props.style);
    if (this.props.onClick) {
      this.props.onClick()
    }
  };
  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <Btn isActive={this.props.active} onMouseDown={this.onToggle} data-tip={this.props.dataTip}>
        {!!this.props.icon ? (this.props.icon) : (this.props.label)}
      </Btn>
    );
  }
}

function getBlockStyle(block: any) {
  switch (block.getType()) {
    case 'blockquote': return 'RichEditor-blockquote';
    default: return null;
  }
}
// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};


const BLOCK_TYPES = [
  {
    label: 'Unordered list', icon: (<svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M44.5312 9.375H16.0156C15.8008 9.375 15.625 9.55078 15.625 9.76562V12.5C15.625 12.7148 15.8008 12.8906 16.0156 12.8906H44.5312C44.7461 12.8906 44.9219 12.7148 44.9219 12.5V9.76562C44.9219 9.55078 44.7461 9.375 44.5312 9.375ZM44.5312 23.2422H16.0156C15.8008 23.2422 15.625 23.418 15.625 23.6328V26.3672C15.625 26.582 15.8008 26.7578 16.0156 26.7578H44.5312C44.7461 26.7578 44.9219 26.582 44.9219 26.3672V23.6328C44.9219 23.418 44.7461 23.2422 44.5312 23.2422ZM44.5312 37.1094H16.0156C15.8008 37.1094 15.625 37.2852 15.625 37.5V40.2344C15.625 40.4492 15.8008 40.625 16.0156 40.625H44.5312C44.7461 40.625 44.9219 40.4492 44.9219 40.2344V37.5C44.9219 37.2852 44.7461 37.1094 44.5312 37.1094ZM5.07812 11.1328C5.07812 11.4919 5.14885 11.8475 5.28627 12.1792C5.42368 12.511 5.62509 12.8124 5.87901 13.0663C6.13292 13.3202 6.43435 13.5216 6.7661 13.659C7.09785 13.7965 7.45342 13.8672 7.8125 13.8672C8.17158 13.8672 8.52715 13.7965 8.8589 13.659C9.19065 13.5216 9.49208 13.3202 9.74599 13.0663C9.99991 12.8124 10.2013 12.511 10.3387 12.1792C10.4761 11.8475 10.5469 11.4919 10.5469 11.1328C10.5469 10.7737 10.4761 10.4182 10.3387 10.0864C10.2013 9.75466 9.99991 9.45323 9.74599 9.19932C9.49208 8.94541 9.19065 8.74399 8.8589 8.60658C8.52715 8.46916 8.17158 8.39844 7.8125 8.39844C7.45342 8.39844 7.09785 8.46916 6.7661 8.60658C6.43435 8.74399 6.13292 8.94541 5.87901 9.19932C5.62509 9.45323 5.42368 9.75466 5.28627 10.0864C5.14885 10.4182 5.07812 10.7737 5.07812 11.1328V11.1328ZM5.07812 25C5.07812 25.3591 5.14885 25.7147 5.28627 26.0464C5.42368 26.3782 5.62509 26.6796 5.87901 26.9335C6.13292 27.1874 6.43435 27.3888 6.7661 27.5262C7.09785 27.6636 7.45342 27.7344 7.8125 27.7344C8.17158 27.7344 8.52715 27.6636 8.8589 27.5262C9.19065 27.3888 9.49208 27.1874 9.74599 26.9335C9.99991 26.6796 10.2013 26.3782 10.3387 26.0464C10.4761 25.7147 10.5469 25.3591 10.5469 25C10.5469 24.6409 10.4761 24.2853 10.3387 23.9536C10.2013 23.6219 9.99991 23.3204 9.74599 23.0665C9.49208 22.8126 9.19065 22.6112 8.8589 22.4738C8.52715 22.3364 8.17158 22.2656 7.8125 22.2656C7.45342 22.2656 7.09785 22.3364 6.7661 22.4738C6.43435 22.6112 6.13292 22.8126 5.87901 23.0665C5.62509 23.3204 5.42368 23.6219 5.28627 23.9536C5.14885 24.2853 5.07812 24.6409 5.07812 25V25ZM5.07812 38.8672C5.07812 39.2263 5.14885 39.5818 5.28627 39.9136C5.42368 40.2453 5.62509 40.5468 5.87901 40.8007C6.13292 41.0546 6.43435 41.256 6.7661 41.3934C7.09785 41.5308 7.45342 41.6016 7.8125 41.6016C8.17158 41.6016 8.52715 41.5308 8.8589 41.3934C9.19065 41.256 9.49208 41.0546 9.74599 40.8007C9.99991 40.5468 10.2013 40.2453 10.3387 39.9136C10.4761 39.5818 10.5469 39.2263 10.5469 38.8672C10.5469 38.5081 10.4761 38.1525 10.3387 37.8208C10.2013 37.489 9.99991 37.1876 9.74599 36.9337C9.49208 36.6798 9.19065 36.4784 8.8589 36.341C8.52715 36.2035 8.17158 36.1328 7.8125 36.1328C7.45342 36.1328 7.09785 36.2035 6.7661 36.341C6.43435 36.4784 6.13292 36.6798 5.87901 36.9337C5.62509 37.1876 5.42368 37.489 5.28627 37.8208C5.14885 38.1525 5.07812 38.5081 5.07812 38.8672V38.8672Z" fill="#8896a4" />
    </svg>
    ), style: 'unordered-list-item'
  },
  {
    label: 'Ordered list', icon: (<svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.625 35.9375C15.625 35.5231 15.7896 35.1257 16.0826 34.8326C16.3757 34.5396 16.7731 34.375 17.1875 34.375H45.3125C45.7269 34.375 46.1243 34.5396 46.4174 34.8326C46.7104 35.1257 46.875 35.5231 46.875 35.9375C46.875 36.3519 46.7104 36.7493 46.4174 37.0424C46.1243 37.3354 45.7269 37.5 45.3125 37.5H17.1875C16.7731 37.5 16.3757 37.3354 16.0826 37.0424C15.7896 36.7493 15.625 36.3519 15.625 35.9375ZM15.625 23.4375C15.625 23.0231 15.7896 22.6257 16.0826 22.3326C16.3757 22.0396 16.7731 21.875 17.1875 21.875H45.3125C45.7269 21.875 46.1243 22.0396 46.4174 22.3326C46.7104 22.6257 46.875 23.0231 46.875 23.4375C46.875 23.8519 46.7104 24.2493 46.4174 24.5424C46.1243 24.8354 45.7269 25 45.3125 25H17.1875C16.7731 25 16.3757 24.8354 16.0826 24.5424C15.7896 24.2493 15.625 23.8519 15.625 23.4375ZM15.625 10.9375C15.625 10.5231 15.7896 10.1257 16.0826 9.83265C16.3757 9.53962 16.7731 9.375 17.1875 9.375H45.3125C45.7269 9.375 46.1243 9.53962 46.4174 9.83265C46.7104 10.1257 46.875 10.5231 46.875 10.9375C46.875 11.3519 46.7104 11.7493 46.4174 12.0424C46.1243 12.3354 45.7269 12.5 45.3125 12.5H17.1875C16.7731 12.5 16.3757 12.3354 16.0826 12.0424C15.7896 11.7493 15.625 11.3519 15.625 10.9375Z" fill="#8896a4" />
      <path d="M5.35313 37.0781V35.5969H6.25C6.92812 35.5969 7.38437 35.1688 7.38437 34.6063C7.38437 34.0281 6.89063 33.6375 6.25625 33.6375C5.55938 33.6375 5.10937 34.1125 5.09062 34.6063H3.24688C3.29688 33.1469 4.4125 32.1469 6.32813 32.1469C8.16563 32.1406 9.30938 33.0563 9.31875 34.3438C9.32467 34.7854 9.17321 35.2146 8.8915 35.5547C8.60979 35.8949 8.21622 36.1236 7.78125 36.2V36.3031C8.27441 36.3399 8.7344 36.5654 9.06558 36.9326C9.39675 37.2999 9.57361 37.7807 9.55938 38.275C9.56875 39.9406 7.99062 40.775 6.275 40.775C4.225 40.775 3.15 39.6188 3.125 38.2938H4.94375C4.96875 38.85 5.525 39.25 6.2625 39.2594C7.05625 39.2594 7.5875 38.8063 7.58125 38.1656C7.575 37.5563 7.09688 37.0781 6.2875 37.0781H5.35H5.35313ZM5.34062 22.3938H3.45313V22.2844C3.45313 21.0094 4.375 19.6469 6.44687 19.6469C8.26875 19.6469 9.44688 20.6656 9.44688 22.0094C9.44688 23.225 8.64375 23.9375 7.95937 24.6594L6.28125 26.4469V26.5406H9.575V28.125H3.57188V26.8906L6.5625 23.7969C6.99375 23.3531 7.47812 22.8469 7.47812 22.2094C7.47812 21.6469 7.01875 21.2094 6.40938 21.2094C6.2687 21.2042 6.12845 21.2279 5.99728 21.279C5.8661 21.3301 5.74678 21.4075 5.64665 21.5065C5.54653 21.6054 5.46772 21.7238 5.41509 21.8544C5.36246 21.985 5.33712 22.1249 5.34062 22.2656V22.3938ZM8.0125 15.625H6.02813V9.13751H5.93125L4.0625 10.45V8.67814L6.02813 7.29376H8.0125V15.625Z" fill="#8896a4" />
    </svg>
    ), style: 'ordered-list-item'
  },
  {
    label: 'Code block', icon: (<svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.7446 5.14686C32.8049 4.9507 32.826 4.74458 32.8067 4.54026C32.7873 4.33594 32.728 4.13744 32.6319 3.95607C32.5359 3.77471 32.405 3.61404 32.2469 3.48324C32.0887 3.35243 31.9064 3.25406 31.7102 3.19374C31.5141 3.13341 31.3079 3.11231 31.1036 3.13165C30.8993 3.15098 30.7008 3.21037 30.5194 3.30642C30.3381 3.40247 30.1774 3.5333 30.0466 3.69145C29.9158 3.84959 29.8174 4.03195 29.7571 4.22811L17.2571 44.8531C17.1353 45.2493 17.1758 45.6776 17.3698 46.0439C17.5638 46.4102 17.8953 46.6844 18.2915 46.8062C18.6876 46.9281 19.116 46.8875 19.4823 46.6936C19.8485 46.4996 20.1228 46.168 20.2446 45.7719L32.7446 5.14686V5.14686ZM15.1696 12.9562C15.3151 13.1014 15.4305 13.2738 15.5093 13.4636C15.5881 13.6535 15.6286 13.857 15.6286 14.0625C15.6286 14.268 15.5881 14.4715 15.5093 14.6613C15.4305 14.8512 15.3151 15.0236 15.1696 15.1687L5.33522 25L15.1696 34.8312C15.463 35.1246 15.6278 35.5226 15.6278 35.9375C15.6278 36.3524 15.463 36.7503 15.1696 37.0437C14.8762 37.3371 14.4783 37.502 14.0633 37.502C13.6484 37.502 13.2505 37.3371 12.9571 37.0437L2.01959 26.1062C1.87408 25.9611 1.75863 25.7887 1.67986 25.5988C1.60109 25.409 1.56055 25.2055 1.56055 25C1.56055 24.7945 1.60109 24.591 1.67986 24.4011C1.75863 24.2113 1.87408 24.0389 2.01959 23.8937L12.9571 12.9562C13.1022 12.8107 13.2747 12.6953 13.4645 12.6165C13.6543 12.5377 13.8578 12.4972 14.0633 12.4972C14.2689 12.4972 14.4724 12.5377 14.6622 12.6165C14.852 12.6953 15.0244 12.8107 15.1696 12.9562V12.9562ZM34.8321 12.9562C34.6866 13.1014 34.5711 13.2738 34.4924 13.4636C34.4136 13.6535 34.373 13.857 34.373 14.0625C34.373 14.268 34.4136 14.4715 34.4924 14.6613C34.5711 14.8512 34.6866 15.0236 34.8321 15.1687L44.6665 25L34.8321 34.8312C34.6868 34.9765 34.5716 35.149 34.493 35.3388C34.4143 35.5286 34.3739 35.732 34.3739 35.9375C34.3739 36.1429 34.4143 36.3464 34.493 36.5362C34.5716 36.726 34.6868 36.8985 34.8321 37.0437C34.9774 37.189 35.1498 37.3043 35.3396 37.3829C35.5295 37.4615 35.7329 37.502 35.9383 37.502C36.1438 37.502 36.3472 37.4615 36.537 37.3829C36.7268 37.3043 36.8993 37.189 37.0446 37.0437L47.9821 26.1062C48.1276 25.9611 48.243 25.7887 48.3218 25.5988C48.4006 25.409 48.4411 25.2055 48.4411 25C48.4411 24.7945 48.4006 24.591 48.3218 24.4011C48.243 24.2113 48.1276 24.0389 47.9821 23.8937L37.0446 12.9562C36.8994 12.8107 36.727 12.6953 36.5372 12.6165C36.3474 12.5377 36.1439 12.4972 35.9383 12.4972C35.7328 12.4972 35.5293 12.5377 35.3395 12.6165C35.1497 12.6953 34.9772 12.8107 34.8321 12.9562V12.9562Z" fill="#8896a4" />
    </svg>
    ), style: 'code-block'
  },
];

const BlockStyleControls = (props: any) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  let arr = BLOCK_TYPES
  return (
    <>
      {arr.map((type) => {
        if (type.label === 'Delete') {
          return (<StyleButton
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            icon={type.icon}
            dataTip={'Discard'}
            onToggle={() => {
              if (props.onDeleteHandler) {
                props.onDeleteHandler()
              }
            }}
            style={type.style}
          />)
        }
        return (<StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          icon={type.icon}
          onToggle={props.onToggle}
          dataTip={type.label}
          style={type.style}
        />)
      }
      )}
    </>
  );
};

var INLINE_STYLES = [
  {
    label: 'Bold', icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.061 11.22C17.6659 10.442 17.9961 9.48551 18 8.5C18 6.019 15.981 4 13.5 4H6V19H14C16.481 19 18.5 16.981 18.5 14.5C18.4987 13.8837 18.3702 13.2743 18.1226 12.7099C17.875 12.1456 17.5136 11.6383 17.061 11.22V11.22ZM13.5 7C14.327 7 15 7.673 15 8.5C15 9.327 14.327 10 13.5 10H9V7H13.5ZM14 16H9V13H14C14.827 13 15.5 13.673 15.5 14.5C15.5 15.327 14.827 16 14 16Z" fill="#8896a4" />
    </svg>
    ), style: 'BOLD'
  },
  {
    label: 'Italic', icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2809 5.33335H11.4009C11.2992 5.32362 11.1965 5.33525 11.0996 5.36751C11.0026 5.39977 10.9135 5.45194 10.8378 5.52067C10.7622 5.58941 10.7018 5.67319 10.6604 5.76664C10.6191 5.8601 10.5977 5.96116 10.5977 6.06335C10.5977 6.16554 10.6191 6.26661 10.6604 6.36006C10.7018 6.45351 10.7622 6.53729 10.8378 6.60603C10.9135 6.67476 11.0026 6.72693 11.0996 6.75919C11.1965 6.79145 11.2992 6.80308 11.4009 6.79335H12.8209L8.74091 17.0334H6.98091C6.87918 17.0236 6.77654 17.0353 6.67958 17.0675C6.58261 17.0998 6.49346 17.1519 6.41783 17.2207C6.34221 17.2894 6.28179 17.3732 6.24044 17.4666C6.19909 17.5601 6.17773 17.6612 6.17773 17.7634C6.17773 17.8655 6.19909 17.9666 6.24044 18.0601C6.28179 18.1535 6.34221 18.2373 6.41783 18.306C6.49346 18.3748 6.58261 18.4269 6.67958 18.4592C6.77654 18.4914 6.87918 18.5031 6.98091 18.4934H11.8676C11.9693 18.5031 12.0719 18.4914 12.1689 18.4592C12.2659 18.4269 12.355 18.3748 12.4307 18.306C12.5063 18.2373 12.5667 18.1535 12.608 18.0601C12.6494 17.9666 12.6707 17.8655 12.6707 17.7634C12.6707 17.6612 12.6494 17.5601 12.608 17.4666C12.5667 17.3732 12.5063 17.2894 12.4307 17.2207C12.355 17.1519 12.2659 17.0998 12.1689 17.0675C12.0719 17.0353 11.9693 17.0236 11.8676 17.0334H10.3409L14.4276 6.79335H16.2809C16.3826 6.80308 16.4853 6.79145 16.5822 6.75919C16.6792 6.72693 16.7684 6.67476 16.844 6.60603C16.9196 6.53729 16.98 6.45351 17.0214 6.36006C17.0627 6.26661 17.0841 6.16554 17.0841 6.06335C17.0841 5.96116 17.0627 5.8601 17.0214 5.76664C16.98 5.67319 16.9196 5.58941 16.844 5.52067C16.7684 5.45194 16.6792 5.39977 16.5822 5.36751C16.4853 5.33525 16.3826 5.32362 16.2809 5.33335V5.33335Z" fill="#8896a4" />
    </svg>
    ), style: 'ITALIC'
  },
  {
    label: 'Underline', icon: (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9994 18.78C15.3861 18.78 17.6527 16.7266 17.6527 12.78V5.6933C17.6527 5.48997 17.572 5.29497 17.4282 5.15119C17.2844 5.00741 17.0894 4.92664 16.8861 4.92664C16.6827 4.92664 16.4877 5.00741 16.3439 5.15119C16.2002 5.29497 16.1194 5.48997 16.1194 5.6933V12.8933C16.1194 15.8533 14.5327 17.3666 12.0327 17.3666C9.53272 17.3666 7.89272 15.72 7.89272 12.8V5.6933C7.89272 5.48997 7.81195 5.29497 7.66817 5.15119C7.52439 5.00741 7.32939 4.92664 7.12606 4.92664C6.92272 4.92664 6.72772 5.00741 6.58394 5.15119C6.44016 5.29497 6.35939 5.48997 6.35939 5.6933V12.8933C6.35272 16.7266 8.66606 18.78 11.9994 18.78Z" fill="#8896a4" />
      <path d="M20.6672 20H3.3339C3.15062 20.0175 2.98042 20.1026 2.85656 20.2388C2.7327 20.3751 2.66406 20.5526 2.66406 20.7367C2.66406 20.9208 2.7327 21.0983 2.85656 21.2345C2.98042 21.3707 3.15062 21.4559 3.3339 21.4733H20.6672C20.8505 21.4559 21.0207 21.3707 21.1446 21.2345C21.2684 21.0983 21.3371 20.9208 21.3371 20.7367C21.3371 20.5526 21.2684 20.3751 21.1446 20.2388C21.0207 20.1026 20.8505 20.0175 20.6672 20Z" fill="#8896a4" />
    </svg>
    ), style: 'UNDERLINE'
  },
  // { label: 'Monospace', style: 'CODE' },
];

const InlineStyleControls = (props: any) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();

  let arr = INLINE_STYLES
  return (
    <>
      {arr.map(type => {
        return (
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            icon={type.icon}
            onToggle={props.onToggle}
            style={type.style}
            dataTip={type.label}
            tooltip='test'
          />
        )
      }
      )}
    </>
  );
};
export const Profile: React.FC<IProfileProps> = ({ }) => {
  // const [patientFacingName, setpatientFacingName] = useState<string>();
  // const [yearStarting, setYearStarting] = useState<string>();
  // const [picture, setPicture] = useState<string | null>();
  const { data, loading, error } = useQuery<IGetProfileOutput, IGetProfileInput>(GET_PROFILE)
  console.log({ data })
  // const [saveProfile, { data: SaveProfileData, loading: loadingSaveProfile, error: errorSaveProfile }] = useMutation<IChangeProfileOutput, IChangeProfileInput>(CHANGE_PROFILE)

  // const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  // const [editorStateQ1, setEditorStateQ1] = useState(() => EditorState.createEmpty());
  // const [editorStateQ2, setEditorStateQ2] = useState(() => EditorState.createEmpty());
  // const [editorStateEducation, setEditorStateEducation] = useState(() => EditorState.createEmpty());
  // const [editorStateExperience, setEditorStateExperience] = useState(() => EditorState.createEmpty());

  // const inputRef = useRef<any>();
  // const inputRefQ1 = useRef<any>();
  // const inputRefQ2 = useRef<any>();
  // const inputRefEducation = useRef<any>();
  // const inputRefExperience = useRef<any>();

  // useEffect(() => {
  //   if (loading) return
  //   if (data && data.getProviderProfile) {
  //     setpatientFacingName(data.getProviderProfile.patientFacingName)
  //     setPicture(data.getProviderProfile.picture)
  //     setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data.getProviderProfile.bio || '').contentBlocks)))
  //     setEditorStateQ1(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data.getProviderProfile.question1 || '').contentBlocks)))
  //     setEditorStateQ2(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data.getProviderProfile.question2 || '').contentBlocks)))
  //     setEditorStateEducation(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data.getProviderProfile.education || '').contentBlocks)))
  //     setEditorStateExperience(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data.getProviderProfile.experience || '').contentBlocks)))
  //     setYearStarting(data.getProviderProfile.startingYear)
  //   }
  // }, [loading, data])

  // // const getWordCount=(editorState: EditorState)=> {
  // //   const plainText = editorState.getCurrentContent().getPlainText('');
  // //   const regex = /(?:\r\n|\r|\n)/g;  // new line, carriage return, line feed
  // //   const cleanString = plainText.replace(regex, ' ').trim(); // replace above characters w/ space
  // //   return cleanString.length
  // //   // const wordArray = cleanString.match(/\S+/g);  // matches words according to whitespace
  // //   // return wordArray ? wordArray.length : 0;
  // // }

  // const onChange = (e: any) => {
  //   setEditorState(e)
  // }
  // const onChangeQ1 = (e: any) => {
  //   setEditorStateQ1(e)
  // }
  // const onChangeQ2 = (e: any) => {
  //   setEditorStateQ2(e)
  // }
  // const onChangeEducation = (e: any) => {
  //   setEditorStateEducation(e)
  // }
  // const onChangeExperience = (e: any) => {
  //   setEditorStateExperience(e)
  // }
  // const _onTab = (e: any, es: EditorState) => {
  //   const maxDepth = 4;
  //   onChange(RichUtils.onTab(e, es, maxDepth));
  // }

  // const toggleBlockType = (blockType: any) => {
  //   onChange(
  //     RichUtils.toggleBlockType(
  //       editorState,
  //       blockType
  //     )
  //   );
  // }

  // const toggleBlockTypeQ1 = (blockType: any) => {
  //   onChangeQ1(
  //     RichUtils.toggleBlockType(
  //       editorStateQ1,
  //       blockType
  //     )
  //   );
  // }

  // const toggleBlockTypeQ2 = (blockType: any) => {
  //   onChangeQ2(
  //     RichUtils.toggleBlockType(
  //       editorStateQ2,
  //       blockType
  //     )
  //   );
  // }

  // const toggleBlockTypeExperience = (blockType: any) => {
  //   onChangeExperience(
  //     RichUtils.toggleBlockType(
  //       editorStateExperience,
  //       blockType
  //     )
  //   );
  // }

  // const toggleBlockTypeEducation = (blockType: any) => {
  //   onChangeEducation(
  //     RichUtils.toggleBlockType(
  //       editorStateEducation,
  //       blockType
  //     )
  //   );
  // }

  // const toggleInlineStyle = (inlineStyle: any) => {
  //   onChange(
  //     RichUtils.toggleInlineStyle(
  //       editorState,
  //       inlineStyle
  //     )
  //   );
  // }

  // const toggleInlineStyleQ1 = (inlineStyle: any) => {
  //   onChangeQ1(
  //     RichUtils.toggleInlineStyle(
  //       editorStateQ1,
  //       inlineStyle
  //     )
  //   );
  // }

  // const toggleInlineStyleQ2 = (inlineStyle: any) => {
  //   onChangeQ2(
  //     RichUtils.toggleInlineStyle(
  //       editorStateQ2,
  //       inlineStyle
  //     )
  //   );
  // }

  // const toggleInlineStyleEducation = (inlineStyle: any) => {
  //   onChangeEducation(
  //     RichUtils.toggleInlineStyle(
  //       editorStateEducation,
  //       inlineStyle
  //     )
  //   );
  // }

  // const toggleInlineStyleExperience = (inlineStyle: any) => {
  //   onChangeExperience(
  //     RichUtils.toggleInlineStyle(
  //       editorStateExperience,
  //       inlineStyle
  //     )
  //   );
  // }

  const _handleKeyCommand = (command: any, es: EditorState, onChange: (ee: any) => void) => {
    const newState = RichUtils.handleKeyCommand(es, command);
    if (newState) {
      onChange(newState);
      return true;
    }
    return false;
  }
  const extractHtml = (editorState: EditorState) => {
    const html = convertToHTML({
      entityToHTML: (entity, originalText) => {
        if (entity.type === 'LINK') {
          return <a href={entity.data.url}>{originalText}</a>;
        }
        if (entity.type === 'mention') {
          /* tslint:disable-next-line */
          return <b className="mention-highlight">{originalText}</b>
        }
        return originalText;
      }
    })(editorState.getCurrentContent());

    return html
  }
  const onSave = () => {
    //   const res = {
    //     patientFacingName,
    //     bio: extractHtml(editorState),
    //     question1: extractHtml(editorStateQ1),
    //     question2: extractHtml(editorStateQ2),
    //     education: extractHtml(editorStateEducation),
    //     experience: extractHtml(editorStateExperience),
    //     startingYear: yearStarting
    //   }

    //   saveProfile({
    //     variables: res
    //   })
  }

  if (!!loading || !data || !data.getHealthCoachProfile) {
    return <PleaseWait />
  }
  return (
    <Container flexDirection={'column'} style={{ height: '100%', maxHeight: '100%' }} overflow={'hidden'}>
      <Flex justifyContent={'center'} flexDirection={['column', 'row', 'row']}>
        <Flex flexDirection={'column'} flex={1}>
          <Heading mb={3}>Your Profile</Heading>
        </Flex>
        {/* <Button onClick={onSave} variant="pink" style={{
          margin: '0 auto',
          height: 'fit-content',
          borderRadius: '10px',
          paddingLeft: '40px',
          paddingRight: '40px'
        }}>Save</Button> */}
      </Flex>
      <Divider />
      <Flex flexDirection={'column'}  overflowX={'hidden'} overflowY={'auto'}>

        <Flex flexDirection={['column', 'row', 'row']}>
          <Flex flexDirection={'column'} width={'250px'} mr={'20px'} justifyContent='center'>
            <Text fontSize={'16px'} fontWeight={400}>display name</Text>
          </Flex>
          <Flex flex={1}>
            <InputFakeViewer value={data.getHealthCoachProfile.displayName} containerStyle={{ width: '100%', border: '1px solid #C9C9C9', borderRadius: '10px' }} />
          </Flex>
        </Flex>
        <Divider />
        <Flex>
          <Flex flexDirection={'column'} width={'250px'} mr={'20px'} justifyContent='center'>
            <Text fontSize={'16px'} fontWeight={400}>Your photo</Text>
          </Flex>
          <Flex flex={1}>
            <AvatarImg style={{ alignSelf: 'center' }}>
              {!!data.getHealthCoachProfile.thumbnail && (
                <img
                  alt=""
                  src={data.getHealthCoachProfile.thumbnail}
                />
              )}
            </AvatarImg>
          </Flex>
        </Flex>
        <Divider />
        <Flex flexDirection={['column', 'row', 'row']}>
          <Flex flexDirection={'column'} width={['', '250px', '250px']} mr={'20px'}>
            <Text fontSize={'16px'} fontWeight={400}>Your bio</Text>
            <Text mt={[2, 20, 20]} mb={[2, 0, 0]} fontSize={'14px'} opacity={0.6} fontWeight={300}>Bio</Text>
          </Flex>
          <Flex flex={1} flexDirection='column'>
            <InputFakeViewer style={{height: 'fit-content', whiteSpace: 'pre-wrap', maxWidth: '100%'}} value={data.getHealthCoachProfile.bio} containerStyle={{ width: '100%', border: '1px solid #C9C9C9', borderRadius: '10px' }} />

          </Flex>
        </Flex>
        <Divider />
      </Flex>

    </Container>);
}